// extracted by mini-css-extract-plugin
export default {"maxWidthInPc":"450px","modalContainerStyle":"styleModule_modalContainerStyle__mpbq+"};